module.exports = __webpack_public_path__ + "img/advance-2-2.svg";